import { SURVEY } from '@constants/terminology';
import { QuestionSelectingFilter } from '../../question-selecting-filter/QuestionSelectingFilter';
import { QuestionData } from '@routes/custom-dashboard/utils';
import { checkIsTextInput } from '@features/custom-dashboard/question-selecting-filter/utils';
import { DisplayMode } from '@g17eco/types/insight-custom-dashboard';
import { FormGroup, Input } from 'reactstrap';

interface Props {
  initiativeId: string;
  handleSelectQuestion: (data: QuestionData) => void;
  questionData?: QuestionData;
  displayMode?: DisplayMode;
  onChangeDisplayMode: (mode: DisplayMode) => void;
}

export const MetricText = ({
  initiativeId,
  handleSelectQuestion,
  questionData,
  displayMode,
  onChangeDisplayMode,
}: Props) => {
  return (
    <>
      <p className='mt-3 text-medium'>Select data-point from {SURVEY.SINGULAR} scope</p>
      <QuestionSelectingFilter
        questionData={questionData}
        initiativeId={initiativeId}
        handleSelect={handleSelectQuestion}
        validatingFunc={checkIsTextInput}
      />
      <div className='mt-4 d-flex align-items-center gap-3'>
        <span className={displayMode === DisplayMode.PlainText ? 'text-ThemeTextDark' : 'text-ThemeTextLight'}>
          Plain text
        </span>
        <FormGroup switch className='mb-0'>
          <Input
            type='switch'
            checked={displayMode === DisplayMode.Widget}
            onChange={(e) => onChangeDisplayMode(e.target.checked ? DisplayMode.Widget : DisplayMode.PlainText)}
          />
        </FormGroup>
        <span className={displayMode === DisplayMode.Widget ? 'text-ThemeTextDark' : 'text-ThemeTextLight'}>
          Widget
        </span>
      </div>
    </>
  );
};
